<template>
  <div class="dashboard">
    <el-card>
    <h1>This is an Dashboard page - {{user.email}}</h1>
      <el-tabs type="card" v-model="activeName">
        <el-tab-pane v-for="item in tabMenu" :key="item.id" :label="item.name" :name="String(item.id)"></el-tab-pane>
        <keep-alive>
          <component :is="currentTabComponent"></component>
        </keep-alive>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import DashboardCustomerDevices from '@/components/Dashboard/DashboardCustomer.vue'
import DashboardTimerChart from '@/components/Dashboard/DashboardTimerChart.vue'
export default {
    name: 'Dashboard',
    components: { DashboardCustomerDevices, DashboardTimerChart },
    data: () => {
        return {
            activeName: '0',
            tabMenu: [
                { id: 0, name: 'Customer Devices', componentName: 'DashboardCustomerDevices' },
                { id: 1, name: 'Timer Chart', componentName: 'DashboardTimerChart' }
            ]
        }
    },
    computed: {
        user: get('user/objUser'),
        currentTabComponent () {
            return this.tabMenu[this.activeName].componentName
        }
    }
}
</script>
